/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GenericLists {
    ContactPerson = 100,
    Products = 200,
    ProductTypes = 210,
    Customer = 300,
    CustomerPaymentTerms = 310,
    CustomerPriceGroups = 320,
    CustomerSalesPersonRoles = 330,
    CustomerInvoiceLines = 340,
    CustomerInvoices = 350,
    CustomerPriceLists = 360,
    CustomerCreditNotes = 370,
    CustomerCreditNoteLines = 380,
    Project = 400,
    Attributes = 500,
    SystemSettings = 600,
    Employee = 700,
    DocumentTypes = 710,
    Roles = 720,
    ConfiguratorList = 800,
    Rules = 810,
    ConfiguratorMatrix = 900,
    SystemPackage = 910,
}
